import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost } from "../../services/httpService";
import {
  getPatientCommunicationByPatientIdUrl,
  addNewPatientCommunicationUrl,
  deletePatientCommunicationUrl,
} from "../../apiUrls/apiUrls";

const initialState = {
  isPatientCommunicationLoading: false,
  patientCommunicationData: [],
};

export const addNewPatientCommunicationData = createAsyncThunk(
  "patientCommunication/addNewPatientCommunicationData",
  async (data, thunkApi) => {
    const url = addNewPatientCommunicationUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  }
);

export const getPatientCommunicationByPatientIdData = createAsyncThunk(
  "patientCommunication/getPatientCommunicationByPatientIdData",
  async (data, thunkApi) => {
    const { patientId } = data;
    const respData = await httpGet(
      getPatientCommunicationByPatientIdUrl(patientId)
    );
    return respData;
  }
);

export const deletePatientCommunicationData = createAsyncThunk(
  "patientCommunication/deletePatientCommunicationData",
  async (id) => {
    const url = deletePatientCommunicationUrl(id);
    const respData = await httpGet(url);
    return respData;
  }
);

export const patientCommunicationSlice = createSlice({
  name: "patientCommunication",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addNewPatientCommunicationData.pending, (state, action) => {
        state.isPatientCommunicationLoading = true;
      })
      .addCase(addNewPatientCommunicationData.fulfilled, (state, action) => {
        state.isPatientCommunicationLoading = false;
      })
      .addCase(addNewPatientCommunicationData.rejected, (state, action) => {
        state.isPatientCommunicationLoading = false;
      })
      .addCase(
        getPatientCommunicationByPatientIdData.pending,
        (state, action) => {
          state.isPatientCommunicationLoading = true;
        }
      )
      .addCase(
        getPatientCommunicationByPatientIdData.fulfilled,
        (state, action) => {
          state.isPatientCommunicationLoading = false;
          state.patientCommunicationData = action.payload;
        }
      )
      .addCase(
        getPatientCommunicationByPatientIdData.rejected,
        (state, action) => {
          state.isPatientCommunicationLoading = false;
        }
      )
      .addCase(deletePatientCommunicationData.pending, (state, action) => {
        state.isPatientCommunicationLoading = true;
      })
      .addCase(deletePatientCommunicationData.fulfilled, (state, action) => {
        state.isPatientCommunicationLoading = false;
      })
      .addCase(deletePatientCommunicationData.rejected, (state, action) => {
        state.isPatientCommunicationLoading = false;
      });
  },
});

export const {} = patientCommunicationSlice.actions;

export default patientCommunicationSlice.reducer;
